import { render } from "./Dashboard.vue?vue&type=template&id=31e9676f&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=31e9676f&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=31e9676f&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e9676f"]])

export default __exports__